import { useDispatch, useSelector } from "react-redux";
import {
  updateBookingListData,
  updateBookingDetails,
  updateInvoiceDetails,
  updateDisplayRoomDrawer,
  updateRoomTotalDrawer,
  updateRoomSectionVisible,
  updateChangeDateBoolean,
} from "../../reducer/bookingReducer";

import { updateBookingListData as updateBookingReservationListData } from "../../reducer/bookingReservationReducer";
import moment from "moment";
import { message } from "antd";
import { updateinvoice } from "../../services/invoice";
import { resetState, updateDataChanged } from "../../reducer/nightAuditReducer";
import {buildPriceBreakup} from '../../utils/bookingHelper'

const useEditBookingLogic = (setLoading, roomCountMap, calculationResult) => {
  const dispatch = useDispatch();

  const { hotelDetails } = useSelector((store) => store.login);

  const { dataChanged } = useSelector((store) => store.nightAudit);

  const {
    response,
    bookingDetails,
    roomPriceStructure,
    detailedPriceBreakup,
    selectedRoomWTypeAndNum,
    selectedCheckInDateTime,
    selectedCheckOutDateTime,
    nightsCount,
    mealPlan,
    invoiceDetails,
    taxIncludedInPriceLocalState,
  } = useSelector((store) => store.booking);

  const roomTypes = hotelDetails?.roomTypes ? hotelDetails?.roomTypes : [];
  const { taxResponse } = useSelector((store) => store.tax);

  const isValidate = () => {
    if (
      !Boolean(detailedPriceBreakup) &&
      !Array.isArray(detailedPriceBreakup)
    ) {
      message.info("Please select atleast one room");
      return false;
    }

    if (calculationResult?.total <= 0) {
      message.info("Something went wrong");
      return false;
    }

    return true;
  };

  function calculateNumberOfAdults(detailedPriceBreakup) {
    let noOfAdults = 0;
    detailedPriceBreakup.forEach(dpb=>{
      noOfAdults += dpb?.occupancy || 0;
    })
    return noOfAdults;
  }

  const handleEditRoom = async () => {
    if (!isValidate) {
      return;
    }

    if (Boolean(bookingDetails)) {
      setLoading(true);
      let rooms = [];
      let noOfAdults = calculateNumberOfAdults(detailedPriceBreakup);


      let roomInvoice = Array.isArray(invoiceDetails)
        ? invoiceDetails?.find((Obj) => Obj?.invoiceType === "roomBill")
        : {};

      let addOnBreakup = Boolean(
        roomInvoice?.priceBreakup?.find((Obj) => Obj?.type === "Addons")
      )
        ? roomInvoice?.priceBreakup?.find((Obj) => Obj?.type === "Addons")
        : null;

      let newPriceBreakup = [];
      let requiredPriceBrekupForDiscount = [];

      if (calculationResult?.discount !== 0) {
        requiredPriceBrekupForDiscount = detailedPriceBreakup
          ?.reduce((acc, room) => {
            const existingRoom = acc.find((item) => item.name === room.type);

            if (existingRoom) {
              existingRoom.rate += room.rate;
              existingRoom.count += 1;
            } else {
              acc.push({ name: room.type, rate: room.rate, count: 1 });
            }

            return acc;
          }, [])
          .map((obj) => ({
            name: obj.name,
            rate: obj.rate / obj.count, // Calculate average rate
            count: obj.count,
          }));
      }

      const priceBreakup = buildPriceBreakup(detailedPriceBreakup);
      for (let key in selectedRoomWTypeAndNum) {
        selectedRoomWTypeAndNum[key]?.forEach((Obj) => {
          rooms?.push(Obj?.id);
        });
      }

      newPriceBreakup = priceBreakup?.filter((item) =>
        Object?.keys(selectedRoomWTypeAndNum)?.includes(item.type)
      );

      if (newPriceBreakup?.length === 0) {
        message.info("Please Select at least one Room");
        setLoading(false);
        return false;
      }

      newPriceBreakup = Boolean(addOnBreakup)
        ? [...newPriceBreakup, addOnBreakup]
        : newPriceBreakup;

      const newBookingDetails = JSON.parse(JSON.stringify(bookingDetails));
      newBookingDetails.checkIn = moment(selectedCheckInDateTime).valueOf();
      newBookingDetails.checkOut = moment(selectedCheckOutDateTime).valueOf();
      newBookingDetails.roomCount = roomCountMap;
      newBookingDetails.rooms = rooms;
      newBookingDetails.mealPlan = mealPlan;
      newBookingDetails.adults = noOfAdults;

      await dispatch(updateBookingDetails(newBookingDetails));

      finalInvoiceCalculation(newPriceBreakup, newBookingDetails, detailedPriceBreakup);
    } else {
      setLoading(false);
      message.info("Something Went wrong");
    }
  };

  const finalInvoiceCalculation = async (
    newPriceBreakup,
    newBookingDetails,
    detailedPriceBreakup
  ) => {
    const newInvoiceDetails = JSON.parse(
      JSON.stringify(
        invoiceDetails?.find((Obj) => Obj?.invoiceType === "roomBill")
      )
    );

    newInvoiceDetails.totalTax = calculationResult?.totalTax;

    newInvoiceDetails.discount = calculationResult?.discount;
    newInvoiceDetails.discountInfo = calculationResult?.localDiscountInfo;

    newInvoiceDetails.subTotal = calculationResult?.subTotal;
    newInvoiceDetails.total = calculationResult?.total;

    newInvoiceDetails.priceBreakup = newPriceBreakup;
    newInvoiceDetails.taxIncludedInPrice = Boolean(
      taxIncludedInPriceLocalState
    );
    newInvoiceDetails.detailedPriceBreakup = detailedPriceBreakup;

    const payload = {
      hotelId: newInvoiceDetails?.hotelId,
      id: newInvoiceDetails?.id,
      body: newInvoiceDetails,
    };

    

    const data = await updateinvoice(payload);


    if (Boolean(data?.id)) {
      const updatedData = invoiceDetails?.map((item) => {
        if (item.id === data.id) {
          return data;
        } else return item;
      });

      await dispatch(updateInvoiceDetails(updatedData));
      message.success("Booking Updated");

      const newResponse = JSON.parse(JSON.stringify(response));
        const invoiceIndex = newResponse?.invoices?.findIndex(
          (Obj) => Obj.id === updatedData?.[0].id
        );
        const bookingIndex = newResponse?.bookings?.findIndex(
          (Obj) => Obj.id === newBookingDetails?.id
        );

        newResponse.invoices[invoiceIndex] = updatedData?.[0];
        newResponse.bookings[bookingIndex] = newBookingDetails;

        await dispatch(updateBookingListData(newResponse));
        await dispatch(updateBookingReservationListData(newResponse));
      

      dispatch(updateDisplayRoomDrawer());
      await dispatch(updateRoomTotalDrawer(false));
      await dispatch(updateRoomSectionVisible(false));

      dispatch(updateChangeDateBoolean(false));
      dispatch(resetState());
      dispatch(updateDataChanged(!dataChanged));

      setLoading(false);
    } else message.error("Something Went Wrong");

    setLoading(false);
  };

  return { handleEditRoom };
};

export default useEditBookingLogic;
